import { api } from "../configs/apiConfig";
import axios from "axios";

const APPOINTMENT_ENDPOINT = '/appointment';

class AppointmentService {
    // Get all appointments
    async getAllAppointments() {
        try {
            const response = await api.get(APPOINTMENT_ENDPOINT);
            return response.data;
        } catch (error) {
            console.error('Error fetching appointments:', error);
            throw error;
        }
    }

    // Get a specific appointment by ID
    async getAppointmentById(id) {
        try {
            const response = await api.get(`${APPOINTMENT_ENDPOINT}/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching appointment with ID ${id}:`, error);
            throw error;
        }
    }

    // Get appointments by user ID
    async getAppointmentsByUserId(userId) {
        try {
            const response = await api.get(`${APPOINTMENT_ENDPOINT}/user/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user appointments:', error);
            throw error;
        }
    }

    // Get appointments by organizational unit ID
    async getAppointmentsByUnitId(unitId) {
        try {
            const response = await api.get(`${APPOINTMENT_ENDPOINT}/unit/${unitId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching appointments for unit ${unitId}:`, error);
            throw error;
        }
    }

    // Add a new appointment
    async addAppointment(appointmentData) {
        try {
            const response = await api.post(APPOINTMENT_ENDPOINT, appointmentData);
            return response.data;
        } catch (error) {
            console.error('Error adding appointment:', error);
            throw error;
        }
    }

    // Update an existing appointment
    async updateAppointment(id, appointmentData) {
        try {
            await api.put(`${APPOINTMENT_ENDPOINT}/${id}`, appointmentData);
        } catch (error) {
            console.error(`Error updating appointment with ID ${id}:`, error);
            throw error;
        }
    }

    // Delete an appointment
    async deleteAppointment(id) {
        try {
            await api.delete(`${APPOINTMENT_ENDPOINT}/${id}`);
        } catch (error) {
            console.error(`Error deleting appointment with ID ${id}:`, error);
            throw error;
        }
    }
    
    // Helper method to format appointment data for creation/update
    formatAppointmentData(data) {
        return {
            userId: data.userId,
            organizationalUnitName: data.organizationalUnitName,
            roleName: data.roleName,
            positionTitle: data.positionTitle,
            employmentType: data.employmentType || "Full-time",
            positionMultiplier: data.positionMultiplier || 1.0,
            portion: data.portion || 1.0,
            roleImportance: data.roleImportance,
            impactFactor: data.impactFactor,
            timeValue: data.timeValue,
            startDate: data.startDate || new Date(),
            endDate: data.endDate
        };
    }

    // Calculate role importance before sending to backend
    calculateRoleImportance(data) {
        const positionMult = Number(data.positionMultiplier || 1.0);
        const experienceMult = Number(data.experienceLevelMultiplier || 1.0);
        const educationMult = Number(data.educationlevelMultiplier || 1.0);
        const organizationalMult = Number(data.organizationalLevelMultiplier || 1.0);
        const impactMult = Number(data.impactFactor || 1.0);
        
        return positionMult * experienceMult * educationMult * organizationalMult * impactMult;
    }

    async createAppointment(appointmentData) {
        // Calculate role importance before sending
        appointmentData.roleImportance = this.calculateRoleImportance(appointmentData);
        
        const response = await api.post(APPOINTMENT_ENDPOINT, appointmentData);
        return response.data;
    }
}

export default new AppointmentService(); 